document.documentElement.classList.remove('no-js');

const body = document.body;
const header = document.querySelector('[data-site-header]');
if (header) {
  const overlay = header.dataset.overlay === 'true';
  const updateHeader = () => {
    const scrolled = window.scrollY > 24;
    header.classList.toggle('is-scrolled', scrolled);
    header.classList.toggle('is-overlay', overlay && !scrolled);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

const drawer = document.querySelector('[data-mobile-drawer]');
const setDrawer = (open) => {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  body.classList.toggle('menu-open', open);
};
document.querySelector('[data-menu-open]')?.addEventListener('click', () => setDrawer(true));
document.querySelectorAll('[data-menu-close]').forEach((el) => el.addEventListener('click', () => setDrawer(false)));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setDrawer(false); });

const toast = document.querySelector('[data-cart-toast]');
let toastTimer;
function showToast(message = 'Added to bag') {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
}
function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  const original = button.textContent;
  const iconOnlyButton = button.classList.contains('product-card__plus');
  button.disabled = true;
  button.classList.add('is-loading');
  if (!iconOnlyButton) button.textContent = 'Adding…';
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add item');
    const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
    const cart = await cartResponse.json();
    updateCartCount(cart.item_count);
    showToast();
    form.closest('details')?.removeAttribute('open');
  } catch (error) {
    showToast(error.message || 'Please try again');
  } finally {
    button.disabled = false;
    button.classList.remove('is-loading');
    if (!iconOnlyButton) button.textContent = original;
  }
});

const productSection = document.querySelector('[data-product-section]');
if (productSection) {
  const form = productSection.querySelector('.product-form');
  const variantsNode = productSection.querySelector('[data-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  const hiddenId = form?.querySelector('[data-variant-id]');
  const addButton = form?.querySelector('[name="add"]');
  const priceNode = productSection.querySelector('[data-product-price]');
  const gallery = productSection.querySelector('[data-product-gallery]');
  const galleryTrack = gallery?.querySelector('[data-product-gallery-track]');
  const gallerySlides = galleryTrack ? [...galleryTrack.querySelectorAll('[data-product-slide]')] : [];
  const galleryCurrent = productSection.querySelector('[data-product-gallery-current]');
  const galleryPrev = gallery?.querySelector('[data-gallery-prev]');
  const galleryNext = gallery?.querySelector('[data-gallery-next]');
  const mobileGalleryQuery = window.matchMedia('(max-width: 650px)');
  let galleryIndex = Math.max(0, gallerySlides.findIndex((slide) => slide.classList.contains('is-featured')));
  let galleryDragging = false;
  let galleryAxis = null;
  let galleryStartX = 0;
  let galleryStartY = 0;
  let galleryLastX = 0;
  let galleryStartTime = 0;
  let galleryPointerId = null;

  const isMobileGallery = () => mobileGalleryQuery.matches;
  const clampGalleryIndex = (index) => Math.max(0, Math.min(index, gallerySlides.length - 1));

  const renderGallery = (animate = true) => {
    galleryIndex = clampGalleryIndex(galleryIndex);
    if (galleryCurrent) galleryCurrent.textContent = String(galleryIndex + 1);
    gallerySlides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === galleryIndex);
      slide.setAttribute('aria-hidden', isMobileGallery() && index !== galleryIndex ? 'true' : 'false');
    });
    if (!galleryTrack) return;
    if (isMobileGallery()) {
      galleryTrack.style.transition = animate ? 'transform 420ms cubic-bezier(.22,.61,.36,1)' : 'none';
      galleryTrack.style.transform = `translate3d(${-galleryIndex * 100}%,0,0)`;
    } else {
      galleryTrack.style.transition = '';
      galleryTrack.style.transform = '';
    }
  };

  const setGalleryIndex = (index, animate = true) => {
    galleryIndex = clampGalleryIndex(index);
    renderGallery(animate);
  };

  const goToMedia = (mediaId, behavior = 'smooth') => {
    const index = gallerySlides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
    if (index < 0) return;
    if (isMobileGallery()) {
      setGalleryIndex(index, behavior !== 'auto');
    } else {
      gallerySlides[index].scrollIntoView({ behavior, block: 'start' });
    }
  };

  galleryPrev?.addEventListener('click', () => setGalleryIndex(galleryIndex - 1));
  galleryNext?.addEventListener('click', () => setGalleryIndex(galleryIndex + 1));

  gallery?.addEventListener('keydown', (event) => {
    if (!isMobileGallery()) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setGalleryIndex(galleryIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      setGalleryIndex(galleryIndex + 1);
    }
  });

  gallery?.addEventListener('pointerdown', (event) => {
    if (!isMobileGallery() || gallerySlides.length < 2 || event.button !== 0) return;
    if (event.target.closest('[data-gallery-prev], [data-gallery-next], button, a, input, select, textarea')) return;
    galleryDragging = true;
    galleryAxis = null;
    galleryPointerId = event.pointerId;
    galleryStartX = galleryLastX = event.clientX;
    galleryStartY = event.clientY;
    galleryStartTime = performance.now();
    galleryTrack.style.transition = 'none';
    gallery.classList.add('is-dragging');
    try { gallery.setPointerCapture(event.pointerId); } catch (_) {}
  });

  gallery?.addEventListener('pointermove', (event) => {
    if (!galleryDragging || event.pointerId !== galleryPointerId || !galleryTrack) return;
    const deltaX = event.clientX - galleryStartX;
    const deltaY = event.clientY - galleryStartY;
    galleryLastX = event.clientX;
    if (!galleryAxis && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)) {
      galleryAxis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
    }
    if (galleryAxis !== 'x') return;
    event.preventDefault();
    const resistance = (galleryIndex === 0 && deltaX > 0) || (galleryIndex === gallerySlides.length - 1 && deltaX < 0) ? 0.28 : 1;
    galleryTrack.style.transform = `translate3d(calc(${-galleryIndex * 100}% + ${deltaX * resistance}px),0,0)`;
  }, { passive: false });

  const finishGalleryDrag = (event) => {
    if (!galleryDragging || (event.pointerId != null && event.pointerId !== galleryPointerId)) return;
    const deltaX = galleryLastX - galleryStartX;
    const elapsed = Math.max(1, performance.now() - galleryStartTime);
    const velocity = deltaX / elapsed;
    const width = gallery?.clientWidth || 1;
    galleryDragging = false;
    gallery.classList.remove('is-dragging');
    try { gallery.releasePointerCapture(galleryPointerId); } catch (_) {}
    galleryPointerId = null;
    if (galleryAxis === 'x' && (Math.abs(deltaX) > Math.max(42, width * 0.12) || Math.abs(velocity) > 0.45)) {
      setGalleryIndex(galleryIndex + (deltaX < 0 ? 1 : -1));
    } else {
      renderGallery(true);
    }
    galleryAxis = null;
  };

  gallery?.addEventListener('pointerup', finishGalleryDrag);
  gallery?.addEventListener('pointercancel', finishGalleryDrag);
  gallery?.addEventListener('lostpointercapture', (event) => {
    if (galleryDragging) finishGalleryDrag(event);
  });

  const resetGalleryLayout = () => renderGallery(false);
  mobileGalleryQuery.addEventListener?.('change', resetGalleryLayout);
  window.addEventListener('resize', resetGalleryLayout, { passive: true });
  renderGallery(false);

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  };
  const updateVariant = () => {
    const selected = [...form.querySelectorAll('[data-option-position]')].map((group) => group.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant) {
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      return;
    }
    hiddenId.value = variant.id;
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? addButton.dataset.addText : addButton.dataset.soldText;
    if (priceNode) {
      priceNode.innerHTML = `${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}<span>${formatMoney(variant.price)}</span>`;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    if (variant.featured_media?.id) goToMedia(variant.featured_media.id);
  };
  form?.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', updateVariant));
  const qty = form?.querySelector('[data-qty-input]');
  form?.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); });
  form?.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.value = Number(qty.value || 1) + 1; });
}

const filterDrawer = document.querySelector('.filter-drawer');
document.querySelector('[data-filter-close]')?.addEventListener('click', () => filterDrawer?.removeAttribute('open'));

const recommendations = document.querySelector('[data-product-recommendations]');
if (recommendations && recommendations.dataset.url && recommendations.innerHTML.trim() === '') {
  fetch(recommendations.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) recommendations.innerHTML = replacement.innerHTML;
    })
    .catch(() => {});
}

// Horizontal product sliders used by the Represent-style page template.
document.querySelectorAll('[data-product-slider]').forEach((viewport) => {
  const section = viewport.closest('.rep-product-slider');
  const previous = section?.querySelector('[data-slider-prev]');
  const next = section?.querySelector('[data-slider-next]');
  const move = (direction) => {
    const item = viewport.querySelector('.rep-product-slider__item');
    const distance = item ? item.getBoundingClientRect().width + 14 : viewport.clientWidth * 0.8;
    viewport.scrollBy({ left: distance * direction, behavior: 'smooth' });
  };
  previous?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
});
